export function getLSItemOrEmptyString(key) {
	let item = localStorage.getItem(key);
	if (item == null) {
		item = '';
	}
	return item;
}
